import React from "react";
import { Box, GridItem, SimpleGrid } from "@chakra-ui/react";
import dynamicForm from "./FieldConfig/index.js";

const fullWidthFields = ["features", "pricing", 'description']

const GenericForm = ({ formType, formData, onChange, errors, setErrors }) => {
  const fields = dynamicForm[formType] || {};

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
  {Object.entries(fields).map(([name, renderField]) => {
    const isFullWidth = fullWidthFields.includes(name); 

    const content = renderField({
      name,
      value: formData[name] || "",
      onChange: (name, value) => onChange(name, value),
      formData: formData,
      error: errors[name],
      setErrors: setErrors
    });

    return isFullWidth ? (
      <GridItem key={name} colSpan={2}>
        {content}
      </GridItem>
    ) : (
      <Box key={name}>
        {content}
      </Box>
    );
  })}
</SimpleGrid>
  );
};

export default GenericForm;
